<template>
	<div class="mainWrapper products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Returns</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/returns">
					Back to Returns
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brands (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div>
				<b-datepicker :date-formatter="dateFormatter" placeholder="Starting Date" v-model="startingDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</div>

			<div>
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Ending Date"
					v-model="endingDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</div>

			<div>
				<b-button type="is-info" @click="exportReturns()">Export</b-button>
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20,
			isLoading: false,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			brands: [], // To store brands
			allBrands: [],
			selectedBrand: null,
			brandSuggestions: '',
			returns: [],
			totalLoop: 0,
			progress: 0,
			toExport: [],
			startingDate: null,
			endingDate: null,
			minDate: null,
			maxDate: null
		}
	},

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()

		await this.getBrands()

		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		exportReturns: async function() {
			// Set default data
			this.returns = []
			this.toExport = []

			this.totalLoop = 0
			this.progress = 0

			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Starting and ending dates are required'
				})

				return
			}

			this.isLoading = true

			// To filter with start and end date
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')

			// Set parameters for API
			var data = {
				limit: 1,
				time: {
					createdAt
				}
			}

			// For shop
			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			// For brand
			if (this.selectedBrand) {
				data.brand = this.selectedBrand._id
			}

			const result = await this.$api.getReturnList({ data })

			// Loop to get all data
			if (result) {
				const total = result.data.total
				const totalLoop = Math.ceil(result.data.total / this.limit)

				this.totalLoop = total

				var i

				for (i = 0; i < totalLoop; i++) {
					const skip = i * this.limit

					const result = await this.getReturn(skip)

					result.map(item => {
						this.returns.push(item)
					})
				}

				this.progress = 100
			} else {
				this.$swal.fire({
					icon: 'info',
					title: 'No Data...',
					text: 'Sorry, no data found'
				})

				this.isLoading = false

				return
			}

			if (this.returns.length > 0) {
				for (let result in this.returns) {
					let returnId = this.returns[result]._id

					this.toExport[result] = {}
					this.toExport[result].detail = []
					this.toExport[result].products = []

					var data = {
						id: returnId,
						populate_return_product: ['author', 'shop', 'warehouse', 'brand'],
						populate_return_product_item: ['product']
					}

					const apiDetail = await this.$api.getReturnDetail({ data })

					this.toExport[result].detail = apiDetail.data.return_product
					this.toExport[result].products = apiDetail.data.return_product_items
				}
			}

			if (this.toExport.length > 0) {
				this.generateCSV()
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Nothing found!'
				})
			}
		},

		generateCSV: function() {
			let export_csv = ''

			// Loop data
			this.toExport.map(data => {
				if (data.products.length > 0) {
					export_csv += 'RETURN CODE,DATE,TIME,LOCATION,BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,ADMIN NAME,QUANTITY,REASON,STATUS\r\n'

					let total_quantity = 0
					let total_amount = 0

					// Map all the transfer products
					data.products.map(items => {
						let matchedBrand = this.brands.filter(brand => {
							return brand._id == items.product.brand
						})

						const product_price =
							items.product.commission > 0 || items.product.original_price < 2 ? items.product.price : items.product.original_price

						const toAdd = [
							data.detail.code,
							this.$moment(data.detail.createdAt).format('DD/MM/YY'),
							this.$moment(data.detail.createdAt).format('hh:mm a'),
							this.getLocationName(data.detail),
							items.product.bd_code,
							items.product.barcode,
							'"' + items.product.name + '"',
							data.detail.brand.name,
							data.detail.brand.code,
							data.detail.author.name,
							items.qty,
							data.detail.type[0],
							(status = data.detail.status ? 'OPEN' : 'CLOSED')
						]

						total_quantity += items.qty

						let row = toAdd.join(',')

						export_csv += row + '\r\n'
					})

					export_csv += ',,,,,,,,,Total,' + total_quantity

					export_csv += '\r\n\r\n'
				}
			})

			this.isLoading = false

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Export_Returns_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.returnNumber = null
		},

		getReturn: async function(skip = 0) {
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.startingDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.endingDate)
				.set({ hour: 24 })
				.format('x')
			let data = {
				limit: this.limit,
				populate: ['author', 'shop', 'brand'],
				time: {
					createdAt
				},
				sort: {
					createdAt: 'asc'
				},
				skip
			}

			// For shop
			if (this.selectedShop) {
				data.shop = this.selectedShop._id
			}

			// For brand
			if (this.selectedBrand) {
				data.brand = this.selectedBrand._id
			}

			const result = await this.$api.getReturnList({ data })

			if (result) {
				return result.data.list
			}
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops()

			this.shops = apiGetShops.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.allBrands = apiGetBrands.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		},

		// Get location name - show shop name if available, otherwise warehouse name
		getLocationName: function(returnDetail) {
			if (returnDetail.shop && returnDetail.shop.name) {
				return returnDetail.shop.name
			} else if (returnDetail.warehouse && returnDetail.warehouse.name) {
				return returnDetail.warehouse.name
			}
			return 'N/A'
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';
</style>
